import { Container, Content, Image } from "../styles/Construction.style";
import ImageConstruction from "../assets/building-page.png";

const ConstructionPage = () => {
  return(
    <div>
        <Container>
            <Content>
              <h1>PRÓXIMAMENTE</h1>
              <p>SITIO EN CONSTRUCCIÓN</p>
            </Content>
            <Image>
              <img src={ImageConstruction} alt="Construction" />
            </Image>
        </Container>
    </div>
  )
}

export default ConstructionPage